import LPV2MainProductStateManager from './state-manager';
import { initTitleBlock } from './title';
import { initReviewsBlock } from './reviews';
import { initPriceBlock } from './price';
import { initCopyBlock } from './copy';
import { initSwatchesBlock } from './swatches';
import { initSkioPickerBlock } from './skio-picker';
import { initQuantityBlock } from './quantity';
import { initButtonsBlock } from './buttons';
import { initOOSDispatchBlock } from './oos-dispatch';
import { initGalleryBlock } from './gallery';
import { initOptionsBundleBlock } from './options-bundle';

// Initialize the state manager (can be used by all blocks)
window.lpv2MainProductStateManager = new LPV2MainProductStateManager();

// Block registry - maps block types to their JS init functions
const BLOCK_REGISTRY = {
  'breadcrumbs': {
    selector: '.lpv2-breadcrumbs',
    init: () => {} // Breadcrumbs have inline JS
  },
  'title': {
    selector: '.lpv2-main-product-title',
    init: initTitleBlock
  },
  'reviews': {
    selector: '.lpv2-main-product-reviews',
    init: initReviewsBlock
  },
  'price': {
    selector: '.lpv2-main-product-price-block',
    init: initPriceBlock
  },
  'copy': {
    selector: '.lpv2-main-product-copy',
    init: initCopyBlock
  },
  'options': {
    selector: '.lpv2-main-product-options',
    init: initSwatchesBlock
  },
  'product-options-bundle': {
    selector: '.lpv2-main-product-options-bundle',
    init: initOptionsBundleBlock
  },
  'skio-picker': {
    selector: '.lpv2-main-product-skio-picker-v2',
    init: initSkioPickerBlock
  },
  'quantity': {
    selector: '.lpv2-main-product-quantity',
    init: initQuantityBlock
  },
  'action-buttons': {
    selector: '.lpv2-main-product-buttons',
    init: initButtonsBlock
  },
  'oos-dispatch': {
    selector: '.lpv2-main-product-oos-dispatch',
    init: initOOSDispatchBlock
  },
  'spacer': {
    selector: '.lpv2-main-product-spacer',
    init: () => {} // Spacer blocks don't need JS
  }
};

// Detect and initialize only the blocks that exist on the page
function detectAndInitBlocks() {
  //console.log('LPv2: Starting block detection...');
  
  // Ensure state manager exists
  if (!window.lpv2MainProductStateManager) {
    console.error('LPv2: State manager not found!');
    return [];
  }
  
  const detectedBlocks = [];
  
  // Check each block type
  Object.entries(BLOCK_REGISTRY).forEach(([blockType, config]) => {
    try {
      const elements = document.querySelectorAll(config.selector);
      if (elements.length > 0) {
        detectedBlocks.push({
          type: blockType,
          count: elements.length,
          init: config.init
        });
        //console.log(`LPv2: Found ${elements.length} ${blockType} block(s) with selector: ${config.selector}`);
      } else {
        //console.log(`LPv2: No ${blockType} blocks found with selector: ${config.selector}`);
      }
    } catch (error) {
      console.error(`LPv2: Error checking ${blockType} blocks:`, error);
    }
  });
  
  //console.log(`LPv2: Found ${detectedBlocks.length} block types to initialize`);
  
  // Initialize only the detected blocks
  detectedBlocks.forEach(block => {
    try {
      //console.log(`LPv2: Initializing ${block.type} block...`);
      block.init();
      //console.log(`LPv2: Successfully initialized ${block.type} block`);
    } catch (error) {
      console.error(`LPv2: Failed to initialize ${block.type} block:`, error);
    }
  });
  
  //console.log(`LPv2: Block detection complete. Initialized ${detectedBlocks.length} block types`);

  initGalleryBlock();
  return detectedBlocks;
}

// --- Read initial state from Liquid JSON output ---
function initLPV2MainProduct() {

  
  
  // Ensure state manager is initialized
  if (!window.lpv2MainProductStateManager) {
    console.error('LPv2: State manager not initialized!');
    return;
  }
  
  if (window.LPV2MainProductInitialState && window.lpv2MainProductStateManager) {
    // console.log('LPv2: Setting initial state...');
    // Set all initial state keys (including freebies, sellingPlanGroups, etc.) into the working state
    window.lpv2MainProductStateManager.setState(window.LPV2MainProductInitialState);
    // console.log('LPv2: Initial state set');
  } else {
    // console.log('LPv2: No initial state found');
  }
  
  // Detect and initialize blocks
  const detectedBlocks = detectAndInitBlocks();
  
  // Fallback: if no blocks detected, try static initialization
  if (detectedBlocks.length === 0) {
    // console.log('LPv2: No blocks detected, trying static initialization...');
    try {
      initTitleBlock();
      initReviewsBlock();
      initPriceBlock();
      initCopyBlock();
      initSwatchesBlock();
      initSkioPickerBlock();
      initQuantityBlock();
      initButtonsBlock();
      initOOSDispatchBlock();
      initOptionsBundleBlock();
      // console.log('LPv2: Static initialization complete');
    } catch (error) {
      console.error('LPv2: Static initialization failed:', error);
    }
  }
};

// Export for potential external use
window.LPV2BlockRegistry = BLOCK_REGISTRY;
window.LPV2DetectAndInitBlocks = detectAndInitBlocks; 

initLPV2MainProduct();